let apiconfig = window.apiconfig || {};
let env = process.env;

let serverconfig = {
  WECHAT_APPID: '',
  WECHAT_AUTH_URL: '',
  API: '',
  AK: '',
  PARENT_REGION_ID: '',
  CLIENT_ID: "",
  CLIENT_TOKEN: "",
  CUSTOMRT_TEL: '',
  PAYMENT_API:'',
  DOWNURL: "",
  URLAPI:'',
  APP_KEY: "",
  APP_SECRET: "",
  APP_NAME: "",
};
for (let key in serverconfig) {
  if (Object.prototype.hasOwnProperty.call(serverconfig, key)) {
    serverconfig[key] = apiconfig[key] || env[`VUE_APP_${key}`];
  }
}

export default serverconfig;
